import { Component, EventEmitter, Inject, Input, Output, OnChanges, OnDestroy, OnInit } from '@angular/core';
import { DwComponent, DwComponentType, DwExpressionService, DwMetaDataFormApi, DwMetaDataFormStateService, DwMetaDataService, DwMetaDataServiceToken, DwSectionBaseComponent, DwUiConfigRegistryService, DwUIMetaDataConfig, DwUIMetaDataConfigToken } from '@devwareapps/devware-cap';
import { AppMetaDataItemNames, CheckRideRequestEntity, CheckRideScheduleHoldEntity } from '../../../../meta-data/app-meta-data.service';
import { ScheduleHoldUtilService } from '../../services/schedule-hold-util.service';
import { ApplicantRepositoryService } from '../../../applicant/services/applicant-repository.service';
import { ExaminerRepositoryService } from '../../../examiner/services/examiner-repository.service';
import { DateTimeUtilService } from '../../../shared/util/date-time-util.service';
import { ScheduleHoldResultAction } from '../../../examiner/models/schedule-hold-result.model';
import { CheckrideRefItem } from '../../models/checkride-ref-item.model';
import { combineLatest, Observable } from 'rxjs';



@Component({
  selector: 'app-schedule-hold-info-multiple',
  template: `
    <div class="schedule-hold-info" *ngIf="message">
      <div class="pull-left">
        <i class="fa fa-exclamation-circle fa-2x dw-orange pull-left"></i> <div class="schedule-hold-message pull-left">{{message}}</div>
      </div>
      <div class="pull-right">
        <span class="schedule-hold-expiration-time">{{timeUntilExpiration}}</span>
      </div>
    </div>
  `
})
export class ScheduleHoldInfoMultipleComponent implements OnInit, OnChanges {
  @Input() checkrideRefs: CheckrideRefItem[] = [];
  @Output() returnToSearch = new EventEmitter<any>();


  scheduleHold: CheckRideScheduleHoldEntity;
  minutesUntilExpiration: number;
  secondsUtilExpiration: number;
  timeUntilExpiration: string;
  message: string;


  constructor(
    private examinerRepositoryService: ExaminerRepositoryService,
    private applicantRepositoryService: ApplicantRepositoryService,
    private scheduleHoldUtilService: ScheduleHoldUtilService,
    private dateTimeUtilService: DateTimeUtilService,
  ) {

  }

  ngOnInit(): void {
    this.setupComponent();
  }

  ngOnChanges(): void {
    this.setupScheduleHoldInfo();
  }


  setupComponent(): void {
    //   if (!this.scheduleHoldUtilService.requiredScheduleHold()) {
    //     console.warn('Schedule hold is not required for this checkride');
    //     return;
    //   }

    //   this.scheduleHoldUtilService.getScheduleHoldSubjectChanged().subscribe((result: any) => {
    //     this.setupScheduleHoldInfo();
    //   });

    //   this.setupScheduleHoldInfo();

    //   this.formApi.getFormDataChanges().subscribe((data: any) => {
    //     this.checkRideRequest = data;
    //     this.setupInitialScheduleHold();
    //   });

    //   this.checkRideRequest = this.formApi.getFormData();
    //   this.setupInitialScheduleHold();
  }

  intervalHandle: any = null;

  ngOnDestroy(): void {

    if (this.intervalHandle) {
      clearInterval(this.intervalHandle);
    }

    if (this.scheduleHold) {
     // console.log('Cancelling schedule hold');

      const obs: Observable<any>[] = [];

      for (const checkrideRef of this.checkrideRefs) {

        if (checkrideRef.scheduleHold?.CheckRideScheduleHold) {
          obs.push(this.scheduleHoldUtilService.cancelScheduleHold(checkrideRef.scheduleHold.CheckRideScheduleHold, checkrideRef.checkride));
        }
      };

      if (obs.length >0) {
        combineLatest(obs).subscribe((results) => {
  
        });
      }

    }
  }

  initialScheduleHoldSetup = false;

  setupInitialScheduleHold(): void {

    if (this.initialScheduleHoldSetup) {
      return;
    }

    // Schedule a hold
    this.initialScheduleHoldSetup = true;


    // this.scheduleHoldUtilService.startScheduleHold(this.checkRideRequest)
    //   .subscribe((result) => {
    //     if (result.ResultAction == ScheduleHoldResultAction.holdStarted) {
    //         return;
    //     }

    //     this.scheduleHoldUtilService.returnToSearch(this.checkRideRequest, this.formApi, result.ErrorMessage);
    //   });

    // if (this.checkRideRequest.CheckRideScheduleHold) {
    this.setupScheduleHoldInfo();
    //}

  }

  setupIntervalUpdate(): void {
    this.intervalHandle = setInterval(() => {
      if (!this.scheduleHold) {
        return;
      }

      this.setExpirationTime(this.scheduleHold);

    }, 1000);
  }


  setExpirationTime(scheduleHold: CheckRideScheduleHoldEntity) {
    if (!scheduleHold) {
      return;
    }

    const currentDateTime = this.dateTimeUtilService.getCurrentDateTime();

    this.secondsUtilExpiration = this.dateTimeUtilService.calcDurationSeconds(currentDateTime, scheduleHold.ExpirationDateTime);

    this.timeUntilExpiration = this.dateTimeUtilService.formatDuration(this.secondsUtilExpiration);

    if (this.secondsUtilExpiration <= 0) {
      this.message = 'Your booking slot has expired.';

      this.timeUntilExpiration = '';
      clearInterval(this.intervalHandle);

      this.returnToSearch.emit();

      //this.scheduleHoldUtilService.returnToSearch(this.checkRideRequest, this.formApi, this.message);
    }
  }

  setupScheduleHoldInfo(): void {
    if (!this.checkrideRefs || this.checkrideRefs.length === 0) {
      return;
    }

    const checkrideRef = this.checkrideRefs[0];
    
    this.scheduleHold = checkrideRef.scheduleHold?.CheckRideScheduleHold;

    if (!this.scheduleHold) {
      if (this.intervalHandle) {
        clearInterval(this.intervalHandle);
      }
      return;
    }

    this.setupIntervalUpdate();

    const expirationDateTime = this.dateTimeUtilService.formatDateTimeToLocal(this.scheduleHold.ExpirationDateTime);

    this.message = `We are holding these booking slots for you until ${expirationDateTime}`;
  }

}

